"use client"

import { ColumnDef } from "@tanstack/react-table"
import { Checkbox } from "@/Components/ui/checkbox"
import { Button } from "@/Components/ui/button"
import { MoreHorizontal } from "lucide-react"
import { User } from "./columns"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../../ui/dropdown-menu"
import { useContext } from "react"
import { AppContext } from "@/App"


export type TeamMember = User & {
    projectRole: "Viewer" | "Team Member" | "Sponsor" | "Project Manager"
}

export function get_team_columns(HandleSetRoleClicked: (id: string, role: "Viewer" | "Team Member" | "Sponsor" | "Project Manager") => void, HandleRemoveClicked: (id: string) => void, typeFilter?: "Viewer" | "Team Member" | "Sponsor" | "Project Manager"): ColumnDef<TeamMember>[] {
    const app = useContext(AppContext);
    const columns: ColumnDef<TeamMember>[] = [];

    if (app.authLevel > 3) {
        columns.push(
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={
                            table.getIsAllPageRowsSelected() ||
                            (table.getIsSomePageRowsSelected() && "indeterminate")
                        }
                        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(value) => row.toggleSelected(!!value)}
                        aria-label="Select row"
                    />
                ),
                enableSorting: false,
                enableHiding: false,
            });
    }
    columns.push(
        {
            id: "id",
            accessorKey: "id",
            header: "ID",
            cell: ({ row }) => {
                const id = row.getValue("id");
                return <div className="pl-4">{id as number}</div>
            },
            size: 100,
        },
        {
            id: "forename",
            accessorKey: "forename",
            header: "Forename",
            cell: ({ row }) => {
                const forename = row.getValue("forename");
                return <div className="text-center">{forename as string}</div>
            },
            size: 200,
        },
        {
            id: "surname",
            accessorKey: "surname",
            header: "Surname",
            cell: ({ row }) => {
                const surname = row.getValue("surname");
                return <div className="text-center">{surname as string}</div>
            },
            size: 200,
        },
        {
            id: "displayName",
            accessorKey: "displayName",
            header: "Display Name",
            cell: ({ row }) => {
                const displayName = row.getValue("displayName");
                return <div className="text-center">{displayName as string}</div>
            },
            size: 200,
        },
        {
            id: "email",
            accessorKey: "email",
            header: "Email",
            cell: ({ row }) => {
                const email = row.getValue("email");
                return <div className="text-center">{email as string}</div>
            },
            size: 200,
        });
    //if (!typeFilter) {
        columns.push(
            {
                id: "projectRole",
                accessorKey: "projectRole",
                header: "Role",
                cell: ({ row }) => {
                    const projectRole = row.getValue("projectRole");
                    return <div className="text-center">{projectRole as string}</div>
                },
                size: 200,
            });
   // }
    if (app.authLevel > 3) {
        columns.push(
            {
                id: "actions",
                cell: ({ row }) => {
                    const app = useContext(AppContext);
                    return (
                        <>
                            {app.authLevel > 3 && (
                                <DropdownMenu>
                                    <DropdownMenuTrigger asChild
                                        className="p-0"
                                    >
                                        <Button variant="ghost" className="h-4 w-8 p-0">
                                            <span className="sr-only">Open menu</span>
                                            <MoreHorizontal className="h-4 w-4" />
                                        </Button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="end">
                                        {!typeFilter && (
                                            <>
                                        <DropdownMenuLabel>Set Role</DropdownMenuLabel>
                                        <DropdownMenuItem onClick={() => HandleSetRoleClicked && HandleSetRoleClicked(row.getValue("id"), "Viewer")}>
                                            Viewer
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => HandleSetRoleClicked && HandleSetRoleClicked(row.getValue("id"), "Team Member")}>
                                            Team Member
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => HandleSetRoleClicked && HandleSetRoleClicked(row.getValue("id"), "Sponsor")}>
                                            Sponsor
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => HandleSetRoleClicked && HandleSetRoleClicked(row.getValue("id"), "Project Manager")}>
                                            Project Manager
                                        </DropdownMenuItem>
                                        <DropdownMenuSeparator />
                                        </>
                                        )}
                                        <DropdownMenuLabel>Actions</DropdownMenuLabel>
                                        <DropdownMenuItem onClick={() => HandleRemoveClicked(row.getValue("id"))}>
                                            Remove
                                        </DropdownMenuItem>
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            )}
                        </>
                    )
                },
            });
    }
    return columns;
}

export const columnDisplayNames: [string, string][] = [
    ["id", "ID"],
    ["forename", "Forename"],
    ["surname", "Surname"],
    ["displayName", "Display Name"],
    ["email", "Email"],
    ["projectRole", "Role"]
]